<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-12">

                    <form v-on:submit.prevent="submit">
                        <div class="row">

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>
                                        <label style="color: red; height: 2px;" >*</label>
                                        نام
                                    </label>
                                    <input required class="form-control" v-model="name">
                                </div>
                            </div>

                            <div class="col-md-3">
                                <label>سوویچ</label>
                                <select class="form-control" v-model="switchName">
                                    <option :value="item.id" v-for="(item, index) in switchList" :key="index">{{
                                        item.title }}</option>
                                </select>
                            </div>
                              <div class="col-md-12" >
                                <!-- <label class="custom-switch mt-4">
                                    <input type="checkbox" name="custom-switch-checkbox2" class="custom-switch-input"
                                        v-model="tourist">
                                    <span class="custom-switch-description">توریست</span>
                                    <span class="custom-switch-indicator mx-1 "></span>
                                    <span class="custom-switch-description">اتباع</span>
                                </label> -->
                                <div class="row mt-4 ">
                                    <div class="col-md-3 text-right">
                                        <label class="rdiobox"><input name="rdio" type="radio" value=false v-model="tourist"> <span>اتباع</span></label>
                                    </div>
                                    <div class="col-md-3 text-right">
                                        <label class="rdiobox"><input name="rdio" type="radio" value=true v-model="tourist"> <span>توریست</span></label>
                                    </div>
                                </div>
                            </div>

                        </div>
                         <div class=" row mt-4 px-3 w-100 flex flex-1 items-center ">
                            <button type="submit" class="btn btn-primary" >ذخیره اطلاعات</button>
                            <button v-if="this.$route.params.id && $store.state.role == 'admin' && status !=undefined " :class="[status ? 'btn-danger ': 'btn-success' ,'btn mx-2']" @click="changeStatus"> {{ status ? "غیر فعال سازی کاربر" :"فعال سازی کاربر" }}</button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    
    name: 'CreateOrUpdate',
    data() {
        return {
          switchList:[],
          name : "",
          switchName: 0 ,
          status : undefined,
          tourist: true,
        }
    },
    methods: {
        async getConsumer(){
            this.showLoading = true;
            const data = {"consumerId":this.$route.params.id , "authorizationToken": localStorage.getItem('agc-token')};
            this.$api.post('Organizations/Fida/Consumer/Find' , data ).then(({ data }) => {
                this.switchName = data.result.switchName;
                this.name = data.result.title;
                this.tourist = data.result.tourist,
                this.status = data.result.status,
                this.showLoading = false;
            }).catch(() => {
                this.showLoading = false;
                this.$swal({
                    title: 'ناموفق',
                    icon: 'error',
                    text: ' داده ای  یافت نشد ,لذا مجدد اقدام کنید!'
                })
            })
        },
        async getSwitchData(){
            this.showLoading = true,
            this.$api.get('Organizations/Fida/Consumer/Switch/List').then(({ data }) => {
                this.switchList = data.result;
                this.showLoading = false;
            }).catch(() => {
                this.showLoading = false;
                this.$swal({
                    title: 'ناموفق',
                    icon: 'error',
                    text: ' داده ای  یافت نشد ,لذا مجدد اقدام کنید!'
                })
            })
        },
        async changeStatus(e){
            e.preventDefault();
            this.$dialog
                .confirm('آیا از تغییر وضعیت اطمینان دارید ؟ ')
                .then((dialog) => {
                    this.showLoading = true;
                    let postedData = {
                        "authorizationToken": localStorage.getItem('agc-token'),
                        "consumerId" : this.$route.params.id,
                    };
                    this.$api.post("Organizations/Fida/Consumer/ChangeStatus", postedData).then(({ data }) => {
                        if (data.status) {
                            this.status = !this.status;
                             this.showLoading = false;
                            this.$swal({
                                title: 'تبریک',
                                icon: 'success',
                                text:"وضعیت با موفقیت تغییر یافت."
                            }).then(() => {
                                if(!this.$route.params.id){
                                    this.$router.push({ name: 'organizationForeigners.consumers.list' });
                                }
                            });
                        }
                    }).catch(() => {
                        this.$swal({
                            title: 'ناموفق',
                            icon: 'error',
                            text: ' اطلاعات این کاربر ثبت نشد ,لذا مجدد اقدام کنید!'
                        }).then(() => {
                            this.showLoading = false;
                            if(!this.$route.params.id){
                                    this.$router.push({ name: 'organizationForeigners.consumers.list' });
                            }
                        });
                    }).finally(() => {
                        this.showLoading = false;
                        if (dialog) { dialog.close() }
                    })
                })
        },
        submit() {
            this.$dialog
            .confirm('آیا از درخواست خود اطمینان دارید ؟ ')
            .then((dialog) => {
                this.showLoading = true;
                let postedData = {
                    "authorizationToken": localStorage.getItem('agc-token'),
                    "name": this.name,
                    "tourist": this.tourist,
                    "switchName": this.switchName,
                };
                if(this.$route.params.id){
                    postedData = {...postedData,
                        "id" : this.$route.params.id,
                    }
                    this.$api.patch(  "Organizations/Fida/Consumer/Update", postedData).then(({ data }) => {
                        if (data.status) {
                            this.$swal({
                                title: 'تبریک',
                                icon: 'success',
                                text:this.$route.params.id? "همکار با موفقیت ویرایش شد." : 'همکار جدید با موفقیت ایجاد شد'
                            }).then(() => {
                                if(!this.$route.params.id){
                                    this.$router.push({ name: 'organizationForeigners.consumers.list' });
                                }
                            });
                        }
                    }).catch(() => {
                        this.$swal({
                            title: 'ناموفق',
                            icon: 'error',
                            text: ' اطلاعات این کاربر ثبت نشد ,لذا مجدد اقدام کنید!'
                        }).then(() => {
                            this.showLoading = false;
                            if(!this.$route.params.id){
                                    this.$router.push({ name: 'organizationForeigners.consumers.list' });
                            }
                        });
                    }).finally(() => {
                        this.showLoading = false;
                        if (dialog) { dialog.close() }
                    })
                }else{
                    this.$api.post("Organizations/Fida/Consumer/Register", postedData).then(({ data }) => {
                        if (data.status) {
                            this.$swal({
                                title: 'تبریک',
                                icon: 'success',
                                text:this.$route.params.id? "همکار با موفقیت ویرایش شد." : 'همکار جدید با موفقیت ایجاد شد'
                            }).then(() => {
                                if(!this.$route.params.id){
                                    this.$router.push({ name: 'organizationForeigners.consumers.list' });
                                }
                            });
                        }
                    }).catch(() => {
                        this.$swal({
                            title: 'ناموفق',
                            icon: 'error',
                            text: ' اطلاعات این کاربر ثبت نشد ,لذا مجدد اقدام کنید!'
                        }).then(() => {
                            this.showLoading = false;
                            if(!this.$route.params.id){
                                    this.$router.push({ name: 'organizationForeigners.consumers.list' });
                            }
                        });
                    }).finally(() => {
                        this.showLoading = false;
                        if (dialog) { dialog.close() }
                    })
                }
                
            })
        },
    },
    created() {
        this.getSwitchData();
        if(this.$route.params.id){
            this.getConsumer()
        }
    }
}
</script>
